import { render, staticRenderFns } from "./HelpSchema.vue?vue&type=template&id=6b922c6c"
import script from "./HelpSchema.vue?vue&type=script&lang=js"
export * from "./HelpSchema.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports